import { StyleSheet } from 'aphrodite/no-important';
import { colour } from '../style/base-theme';

const breakdownDefaults = {
  fontSize: 25,
  fontWeight: 600,
  margin: -5
}

export const styles = StyleSheet.create({
  breakdownWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  breakdownPanel: {
    fontSize: 14,
    color: colour.grey[400],
    padding: '3px 10px',
    textAlign: 'center',
    flexGrow: 1
  },
  highlighted: {
    fontWeight: 600,
    color: colour.grey[300],
  },
  breakdownBought: {
    ...breakdownDefaults,
    color: colour.assisted.primaryGradientTop
  },
  breakdownSold: {
    ...breakdownDefaults,
    color: colour.brand.blue
  },
  breakdownCost: {
    ...breakdownDefaults,
    color: colour.energy.primaryGradientTop
  },
  praise: {
    flex: 'none',
    width: '100%',
    textAlign: 'center',
    color: colour.brand.green,
    fontSize: 13,
    fontWeight: 600,
    marginTop: 0,
    marginBottom: 20,
    ':before': {
      fontFamily: 'informetis',
      fontWeight: 200,
      fontSize: 18,
      height: 10,
      color: colour.brand.green,
      content: '"\\E80A"',
      position: 'relative',
      paddingRight: 8,
      top: 2
    }
  },
  desc: {
    flex: 'none',
    width: '100%',
    textAlign: 'center',
    color: colour.grey[400],
    fontSize: 13,
    fontWeight: 400,
    marginTop: 0,
    marginBottom: 20,
    ':before': {
      fontFamily: 'informetis',
      fontWeight: 200,
      fontSize: 16,
      height: 10,
      color: colour.grey[400],
      content: '"\\E806"',
      position: 'relative',
      paddingRight: 3,
      top: 2
    }
  }
});
